const symbols = {
    instances: Symbol('instances')
};

const getInstances = registry => registry[symbols.instances];
const defineInstances = (registry, attributes) => Reflect.defineProperty(registry, symbols.instances, attributes);

class ObjectRegistry {
    constructor (ctor, instances = {}) {
        this.ctor = ctor;
        defineInstances(this, {
            value: instances,
            writable: false,
            enumerable: false,
            configurable: false
        });
    }

    static get symbols () {
        return symbols;
    }

    merge (mergeObject, callback = instance=>instance) {
        const keys = Object.keys(mergeObject);

        return keys.forEach(key => this.set(key, callback(mergeObject[key]), true));
    }

    set (type, instance, override) {
        const ctor = this.ctor;
        const instances = getInstances(this);

        if (!instance instanceof ctor)
            throw new TypeError(`Object must be an instanceof ${ctor.name}`);

        if (!override && this.has(type))
            return false;

        instances[type] = instance;
        return true;
    }

    get (type) {
        const instances = getInstances(this);

        if (!this.has(type))
            return null;

        return instances[type];
    }

    delete (type) {
        const instances = getInstances(this);

        if (!this.has(type))
            return false;

        delete instances[type];
        return true;
    }

    has (type) {
        return getInstances(this).hasOwnProperty(type);
    }
}

export default ObjectRegistry;